/* global Swiper */

import CookieManager from './utils/cookie-manager';

export default function initPopinOnboarding() {
    if (document.querySelector('.popin-onboarding')) {
        new PopinOnboarding(document.querySelector('.popin-onboarding'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class PopinOnboarding {
    constructor($el) {
        this.$el = $el;
        this.$btnClose = this.$el.querySelector('.js-btn-close-popin-onboarding');
        this.$slider = this.$el.querySelector('.popin.swiper');
        this.$btnIntoSlider = this.$slider.querySelectorAll('.cta[data-action]');
        this.init();
    }

    init() {
        const body = document.querySelector('body');
        body.classList.add('noscroll');

        new Swiper(this.$slider, {
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        });

        const swiper = this.$slider.swiper;

        this.$btnClose.addEventListener('click', (evt) => {
            evt.preventDefault();
            body.classList.remove('noscroll');
            this.$el.remove();
            CookieManager.setCookie('popin_onboarding', 'closed', 180);
        });
        
        // Les boutons d'actions
        this.$btnIntoSlider.forEach(btn => {
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (evt.target.dataset.action === 'next') {
                    swiper.slideNext();
                } else {
                    this.$btnClose.click();
                }
            });
        });
        
        // Ferme la popin quand on clique sur le container grisé
        document.addEventListener('click', (evt) => {
            if (evt.target === this.$el) {
                this.$btnClose.click();
            }
        });
    }
}
